module.exports = __webpack_public_path__ + "img/front_pic.15a6c5e1.png";